<template>
  <div v-if="isPreparing">
    <Preparing></Preparing>
  </div>
  <div v-if="!isPreparing">
    <Preparing v-if="isPreparing" />
    <div v-if="!isPreparing" class="container-fluid">
      <div class="dashboard-heading mb-5">
        <h3 class="fs-22 font-weight-regular">ویرایش دوره</h3>
      </div>
      <ul class="nav nav-tabs generic-tab pb-30px" id="myTab" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="edit-course-tab"
            data-toggle="tab"
            href="#edit-course"
            role="tab"
            aria-controls="edit-course"
            aria-selected="true"
          >
            ویرایش اطلاعات پایه
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="edit-image-tab"
            data-toggle="tab"
            href="#edit-image"
            role="tab"
            aria-controls="image"
            aria-selected="true"
          >
            ویرایش تصویر دوره
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="edit-demo-tab"
            data-toggle="tab"
            href="#edit-demo"
            role="tab"
            aria-controls="edit-demo"
            aria-selected="false"
          >
            ویرایش دموی دوره
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="edit-status-tab"
            data-toggle="tab"
            href="#edit-status"
            role="tab"
            aria-controls="edit-status"
            aria-selected="false"
          >
            وضعیت دوره
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane active"
          id="edit-course"
          role="tabpanel"
          aria-labelledby="edit-course-tab"
        >
          <form method="POST" v-on:submit="handleCourseEdit">
            <div class="card card-item">
              <div class="card-body">
                <h3 class="fs-22 font-weight-regular pb-2">اطلاعات پایه</h3>
                <div class="divider"></div>
                <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="label-text">عنوان دوره</label>
                      <input
                        onfocus="this.removeAttribute('readonly');"
                        readonly
                        v-model="crsTitle"
                        class="form-control form-control-register form--control pl-3"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="label-text">شناسه دوره</label>
                      <input
                        onfocus="this.removeAttribute('readonly');"
                        readonly
                        v-model="crsUid"
                        class="form-control form-control-register form--control pl-3"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label class="label-text">دسته بندی</label>
                    <Dropdown
                      :loading="false"
                      :filter="true"
                      class="form-control form-control-register primCom"
                      v-model="selectedCat"
                      :options="categories"
                      optionLabel="Category"
                      placeholder="یک مورد را انتخاب کنید"
                    />
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="label-text">زمان دوره</label>
                      {{ formatTime(crsTime) }}
                      <input
                        onfocus="this.removeAttribute('readonly');"
                        readonly
                        required
                        v-model="crsTime"
                        class="form-control form-control-register form--control pl-3"
                        type="text"
                        placeholder="مثلا 30-11 یعنی 11 ساعت و 30 دقیقه"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="label-text">قیمت دوره</label>
                      {{ formatPrice(toEngDigit(crsPrice)) }} تومان
                      <input
                        v-model="crsPrice"
                        class="form-control form-control-register form--control pl-3"
                        type="number"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="label-text">تخفیف دوره</label>
                      {{ formatPrice(toEngDigit(crsDiscount)) }} تومان
                      <input
                        v-model="crsDiscount"
                        class="form-control form-control-register form--control pl-3"
                        type="number"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label class="label-text">زبان دوره</label>
                    <Dropdown
                      :loading="false"
                      class="form-control form-control-register primCom"
                      v-model="selectedLang"
                      :options="languages"
                      option-value="code"
                      option-label="name"
                      placeholder="یک مورد را انتخاب کنید"
                    />
                  </div>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label class="label-text">شرح دوره</label>
                      <CkEditor
                        @sendContent="getContent"
                        :content="initialData"
                      ></CkEditor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="course-submit-btn-box pb-4">
              <button :disabled="working" type="submit" class="btn theme-btn">
                <div v-if="!working">ویرایش</div>
                <div v-if="working" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
        <div
          class="tab-pane"
          id="edit-image"
          role="tabpanel"
          aria-labelledby="edit-image-tab"
        >
          <h3 class="fs-22 font-weight-regular pb-2">
            تصویر دوره {{ crsTitle }}
          </h3>
          <div class="divider"></div>

          <Image
            imageStyle="width: 150px !important;height: 150px !important;"
            preview
            :src="images"
            alt="Image Text"
          >
            <template #indicator>
              <div class="col">
                <h4>مشاهده تصویر</h4>
                <i class="la la-eye"></i>
              </div>
            </template>
          </Image>
          <form
            method="POST"
            enctype="multipart/form-data"
            v-on:submit="handleImageEdit"
          >
            <div class="card card-item">
              <div class="card-body">
                <h3 class="fs-22 font-weight-regular pb-2">
                  تصویر جدید برای {{ crsTitle }}
                </h3>
                <div class="divider"></div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group mb-0">
                      <label class="label-text">تصاویر دوره</label>
                      <div class="file-upload-wrap">
                        <input
                          onfocus="this.removeAttribute('readonly');"
                          readonly
                          type="file"
                          v-on:change="handleImageUpload($event)"
                          class="file-upload-input"
                        />
                        <span class="file-upload-text"
                          ><i class="la la-cloud-upload mr-2 fs-18"></i>تصاویر
                          را اینجا رها کنید یا برای آپلود کلیک کنید.</span
                        >
                      </div>
                      <!-- file-upload-wrap -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="course-submit-btn-box pb-4">
              <button :disabled="working" type="submit" class="btn theme-btn">
                <div v-if="!working">بارگذاری تصویر جدید</div>
                <div v-if="working" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
        <div
          class="tab-pane"
          id="edit-demo"
          role="tabpanel"
          aria-labelledby="edit-demo-tab"
        >
          <h3 class="fs-22 font-weight-regular pb-2">
            دموی دوره {{ crsTitle }}
          </h3>
          <div class="divider"></div>

          <video width="450" controls :src="demo"></video>
          <form
            method="POST"
            enctype="multipart/form-data"
            v-on:submit="handleDemoEdit"
          >
            <div class="card card-item">
              <div class="card-body">
                <h3 class="fs-22 font-weight-regular pb-2">
                  دموی جدید برای {{ crsTitle }}
                </h3>
                <div class="divider"></div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group mb-0">
                      <label class="label-text">دموی دوره</label>
                      <div class="file-upload-wrap">
                        <input
                          onfocus="this.removeAttribute('readonly');"
                          readonly
                          type="file"
                          v-on:change="handleDemoUpload($event)"
                          class="file-upload-input"
                        />
                        <span class="file-upload-text"
                          ><i class="la la-cloud-upload mr-2 fs-18"></i>دمو را
                          اینجا رها کنید یا برای آپلود کلیک کنید.</span
                        >
                      </div>
                      <!-- file-upload-wrap -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="course-submit-btn-box pb-4">
              <button :disabled="working" type="submit" class="btn theme-btn">
                <div v-if="!working">بارگذاری دموی جدید</div>
                <div v-if="working" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
        <div
          class="tab-pane"
          id="edit-status"
          role="tabpanel"
          aria-labelledby="edit-status"
        >
          <h2 class="fs-22 font-weight-regular pb-2">
            وضعیت دوره ی {{ crsTitle }}
          </h2>
          <div class="divider"></div>

          <form method="POST" v-on:submit="handleStatusEdit">
            <div class="card card-item">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="form-group">
                      <Dropdown
                        disabled="true"
                        :loading="false"
                        class="form-control form-control-register primCom"
                        v-model="status"
                        :options="courseStatus"
                        optionLabel="Name"
                        option-value="Id"
                        placeholder="یک مورد را انتخاب کنید"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import axios from "axios";
import Image from "primevue/image";
import Preparing from "../components/Preparing.vue";
import ls from "localstorage-slim";
import CkEditor from "../components/CkEditor.vue";
import { courseStatuses, languages } from "../constants";
import { DOMAIN } from "../configs";
export default {
  components: {
    Image,
    Preparing,
    CkEditor,
  },
  data() {
    return {
      specificDeleteFile: "",

      domain: DOMAIN,
      initialData: "<p>سلام</p>",
      ckContent: "",
      working: false,
      isPreparing: true,
      me: {},
      courseStatus: courseStatuses,
      showImageProgressValue: false,
      showDemoProgressValue: false,
      showFileProgressValue: false,
      showCrsProgressValue: false,
      msg: [],
      pleaseChoose: "",
      id: "",
      crsTitle: "",
      crsUid: "",
      crsTime: "",
      crsPrice: "",
      crsDiscount: "",
      crsLang: "",
      videos: "",
      images: "",
      newimages: "",
      demo: "",
      files: [],
      newdemo: "",
      isShowing: "",
      newfile: "",

      status: "",
      editingCourse: [],
      categories: [],
      languages: languages,
      selectedCat: "",
      selectedTeacher: "",
      selectedLang: "",
      fileProgressValue: 0,
      demoProgressValue: 0,
      imageProgressValue: 0,
      crsProgressValue: 0,
    };
  },
  watch: {
    initialData() {},
    imageProgressValue() {},
    fileProgressValue() {},
    demoProgressValue() {},
    crsPrice(value) {
      this.crsPrice = value;
      //this.validateFields(value,0);
      this.formatPrice(value);
    },
    crsDiscount(value) {
      this.crsDiscount = value;
      //this.validateFields(value,1);
      this.formatPrice(value);
    },
    selectedLang(value) {
      this.selectedLang = value;
      //this.validateFields(value,2);
    },
    selectedCat(value) {
      this.selectedCat = value;
      //this.validateFields(value,3);
    },
    selectedTeacher(value) {
      this.selectedTeacher = value;
      //this.validateFields(value,4);
    },
  },
  created() {
    this.id = ls.get("editingCourseId");
    this.me = JSON.parse(ls.get("user"));
  },
  async mounted() {
    await this.getCourse();
    await this.getCategories();
    await this.setValues();
    this.isPreparing = false;
  },
  methods: {
    getContent(event) {
      this.ckContent = event;
    },
    mapShowing(key) {
      switch (key) {
        case 0:
          break;

        default:
          return "Good";
      }
    },
    handleImageUpload(event) {
      if (event.target.files[0].size > 1000000) {
        this.$toast.add({
          severity: "error",
          summary: "فایل انتخابی نباید بیش از 1 مگابایت باشد",
          life: 5000,
        });
        return;
      }
      this.newimages = event.target.files;
    },
    handleDemoUpload(event) {
      if (event.target.files[0].size > 50000000) {
        this.$toast.add({
          severity: "error",
          summary: "فایل انتخابی نباید بیش از 50 مگابایت باشد",
          life: 5000,
        });
        return;
      }
      this.newdemo = event.target.files;
    },
    validateFields(value, i) {
      switch (i) {
        case 2:
          if (value === "") {
            this.msg["lang"] = "لطفا زبانی را وارد کنید";
          } else {
            this.msg["lang"] = "";
          }
          break;
        case 3:
          if (value === "") {
            this.msg["cat"] = "لطفا دسته بندی را وارد کنید";
          } else {
            this.msg["cat"] = "";
          }
          break;
        case 4:
          if (value === "") {
            this.msg["teacher"] = "لطفا استادی را وارد کنید";
          } else {
            this.msg["teacher"] = "";
          }
          break;

        default:
          break;
      }
    },
    setValues() {
      this.crsTitle = this.editingCourse.Name;
      this.crsUid = this.editingCourse.Uid;
      this.crsTime = this.editingCourse.Time;
      this.crsPrice = this.editingCourse.Price;
      this.crsDiscount = this.editingCourse.Discount;
      this.selectedTeacher = this.editingCourse.TeacherId;
      this.selectedLang = parseInt(this.editingCourse.Language);
      this.selectedCat = this.categories.find(
        (c) => c.Id === parseInt(this.editingCourse.CategoryId)
      );
      this.initialData = this.editingCourse.Disc;
      this.images = this.domain + this.editingCourse.Image;
      this.demo = this.domain + this.editingCourse.Demo;
      this.files = this.editingCourse.File.split(",");

      this.isShowing = this.editingCourse.Show ? "فعال" : "غیر فعال";
      this.status = this.editingCourse.Status;

      this.isPreparing = false;
    },
    async getCategories() {
      var response = await axios.get("/api/v1/teacher/course/category");
      this.categories = response.data;
    },
    async getCourse() {
      let lk = ls.get("editingCourse");
      await axios
        .get(`/api/v1/teacher/course/${lk.LinkId}`)
        .then((response) => {
          this.editingCourse = response.data;
        });
      this.setValues();
    },
    async handleImageEdit(e) {
      e.preventDefault();
      let formData = new FormData();

      if (!this.newimages) {
        this.$toast.add({
          severity: "warn",
          summary: "فایل جدیدی وارد نشده است",
          life: 3000,
        });
        return;
      }
      this.working = true;
      formData.append("image", this.newimages[0]);
      formData.append("id", this.editingCourse.Id);

      this.showImageProgressValue = true;

      await axios
        .post("/api/v1/teacher/course/edit/image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.imageProgressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "تصویر دوره با موفقیت به روز رسانی شد",
              life: 5000,
            });
            this.working = false;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "خطا در انجام عملیات",
              life: 5000,
            });
            this.working = false;
          }
        });
    },
    async handleDemoEdit(e) {
      e.preventDefault();
      let formData = new FormData();

      if (!this.newdemo) {
        this.$toast.add({
          severity: "warn",
          summary: "فایل جدیدی وارد نشده است",
          life: 3000,
        });
        return;
      }
      formData.append("demo", this.newdemo[0]);
      formData.append("id", this.editingCourse.Id);

      this.showDemoProgressValue = true;
      this.working = true;

      await axios
        .post("/api/v1/teacher/course/edit/demo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.demoProgressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "دموی دوره با موفقیت به روز رسانی شد",
              life: 5000,
            });
            this.working = false;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "خطا در انجام عملیات",
              life: 5000,
            });
            this.working = false;
          }
        });
    },
    async handleCourseEdit(e) {
      e.preventDefault();
      if (this.formatTime(this.crsTime) === -1) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت",
          detail: "لطفا زمان دوره را درست وارد کنید",
          life: 5000,
        });
        this.working = false;
        return;
      }
      if (parseInt(this.crsDiscount) > parseInt(this.crsPrice)) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت",
          detail: "تخفیف دوره نمی تواند از قیمت دوره بیشتر باشد",
          life: 5000,
        });
        this.working = false;
        return;
      }
      if (this.msg.length !== 0) {
        return;
      }

      this.showCrsProgressValue = true;
      this.working = true;
      await axios
        .post("/api/v1/teacher/course/edit/fast", {
          name: this.crsTitle,
          uid: this.crsUid,
          techid: this.me.Id,
          catid: this.selectedCat.Id,
          category: this.selectedCat.Category,
          disc: this.ckContent,
          price: this.crsPrice,
          discount: this.crsDiscount,
          lang: this.selectedLang,
          time: this.crsTime,
          id: this.id,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "اطلاعات دوره با موفقیت به روز رسانی شد",
              life: 5000,
            });
            this.working = false;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "خطا در انجام عملیات",
              life: 5000,
            });
            this.working = false;
          }
        });
    },
  },
};
</script>

<style></style>
